/**
 * Runtime configuration for API URL
 * 
 * This solves the problem of React baking environment variables at build time.
 * Instead, we detect the correct backend URL at runtime based on the current domain.
 * 
 * Logic:
 * - If running on localhost → use localhost:8001
 * - If REACT_APP_BACKEND_URL is set and matches current origin → use it
 * - Otherwise → use current origin (same domain as frontend)
 */

const getBackendUrl = () => {
  // Check if we have an environment variable set
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  
  // For development on localhost
  if (typeof window !== 'undefined' && window.location.hostname === 'localhost') {
    return envUrl || 'http://localhost:8001';
  }
  
  // For production/preview deployments:
  // The backend runs on the same domain as the frontend (via ingress routing)
  // So we can use the current origin
  if (typeof window !== 'undefined') {
    const currentOrigin = window.location.origin;
    
    // If env URL matches current origin, use it (expected case)
    if (envUrl && envUrl.includes(window.location.hostname)) {
      return envUrl;
    }
    
    // Otherwise, use current origin (handles mismatched env vars in production)
    // This is the key fix: when deployed to a new domain, use THAT domain
    if (envUrl && !envUrl.includes(window.location.hostname)) {
      // eslint-disable-next-line no-console
      console.warn(
        `[All Secured] Backend URL drift detected. Bundled REACT_APP_BACKEND_URL="${envUrl}" does not match current origin "${currentOrigin}". Falling back to current origin. If APIs fail, redeploy with the correct REACT_APP_BACKEND_URL.`
      );
    }
    return currentOrigin;
  }
  
  // Fallback for SSR or non-browser environments
  return envUrl || '';
};

export const API_URL = getBackendUrl();

export default API_URL;
